import React from "react";
import logonegro from '../../assets/png/logoempresarialnegro.png'
import Contacto from '../contacto/Contacto';
import { Link } from "react-router-dom";
import logo from '../../assets/logoblack.png'




export default function Regulation() {
  return (
    <div className="contenedor_joinus">
       <nav className="navbar navbar-light mb-5" id="encabezado">
                <Link to="/" className="container-fluid">
                    <img
                    src={logo}
                    width="290"
                    height="550"
                    className="img-fluid d-block mx-auto"
                    alt='logoMingga'
                    />
                </Link>
            </nav>

            <div className="container-fluid">
            <div className="privacy" align="left" id="padding">
              <h4 align="center">ACUERDO 01 DE 2025<br /></h4>
                <h5 align="left"> <b>REGLAMENTO DE LEO CLUB MUNDIAL DE LECTURA</b></h5>
                <br />
                <h4 align="center">CAPITULO I<br /></h4>
                <h5 align="left"> <b>NATURALEZA, OBJETIVOS Y ALCANCES</b></h5>
                <br />
                
                <p>
                <b>Artículo 1. </b>- LEO Club Mundial de Lectura es un programa educativo y cultural diseñado para
                  promover la lectura, la escritura y el multilingüismo entre las personas y
                 comunidades educativas de todo el mundo, para lo cual utiliza herramientas
                 tecnológicas web que permiten el acceso universal, económico y eficiente al programa y
                 sus servicios, como las páginas web, bibliotecas digitales, videos, blogs y redes
                 sociales. El programa utilizará la sigla LEO. 
                  
                 El programa es desarrollado conjuntamente por la Editorial Educativa Bibliocol SAS, responsable 
                 de la selección, edición y publicación de la Biblioteca Digital, y de la Asociación LEO Club Mundial 
                 de Lectura, responsable de la promoción, vinculación y atención de los socios.
                </p>
                <p>
                <b>Artículo 2. - 0bjetivos.</b> LEO busca alcanzar los siguientes objetivos: 
                1. Mejorar el nivel educativo y cultural de las personas, proporcionando medios que
                promuevan la lectura y la escritura en diferentes idiomas. <br />
                2. Fortalecer las competencias comunicativas de las personas para mejorar su
                desempeño en las actividades académicas, laborales, sociales, y para aprovechar las
                crecientes oportunidades que ofrece la red global a través de internet. <br />
                3. Aumentar el número de personas que leen cotidianamente y los índices de horas y
                número de obras leídas por persona al año. <br />
                4. Ofrecer escenarios para que las personas escriban y publiquen sus obras,
                contribuyendo a la expansión del conocimiento y el patrimonio literario nacional y
                universal. <br />
                5. Fomentar el multilingüismo para aumentar las capacidades de las personas para
                entender y comunicarse en varios idiomas con ciudadanos del mundo.
                6. Ofrecer a los socios la oportunidad de generar ingresos permanentes apoyando 
                el crecimiento de LEO en el país y el mundo.
                </p>
                <br />

                <h4 align="center">CAPITULO I<br /></h4>
                <h5 align="left"> <b>SOCIOS</b></h5>
                <br />

                <p>
                <b>Artículo 3. - Socios.</b> Pueden ser socios de LEO las personas naturales en cualquier
                país del mundo, interesadas en participar en los programas de promoción de la lectura,
                la escritura y el multilingüismo. La prioridad de LEO es la comunidad estudiantil, en
                cualquier área y nivel de formación. Los menores de edad deberán contar con la autorización 
                  y tutoría de sus padres o representantes, adjuntando los respectivos documentos al momento de vinculación.
 
                </p>
                <br />
                <p>
                <b>Artículo 4. - Costo de Membrecía.</b> Para pertenecer al Club Mundial de Lectura LEO
                las personas deberán pagar la cuota de asociación que establezcan las respectivas directivas. <br />
                PARAGRAFO. Para el año 2025, la cuota semestral de asociación a LEO se establece en
                COP$50.000 o su equivalente de US12.5 ó €10
                </p>

                <p>
                <b>Artículo 5. – Renovación.</b> Una vez culminado el respectivo semestre, el socio deberá
                renovar la membrecía, para lo cual deberá pagar la respectiva cuota de
                asociación. El no pago de esta cuota conllevará la pérdida de calidad de socio LEO y
                sus beneficios. Al vincularse por primera vez, el socio autoriza que LEO pueda
                descontar la cuota de renovación de los ingresos que tenga en su Cuenta y
                realizar la renovación automática.
                </p>
                <br />
                <p>
                <b>Artículo 6. - Ingreso.</b> La vinculación se realiza por internet a través del portal
                institucional del programa www.clubleo.net. Los interesados deberán diligenciar el
                formulario de registro proporcionando su información en forma veraz y aportando los
                soportes requeridos en cada caso. Cualquier falsedad de la información o los soportes
                aportados en la vinculación dará lugar a la anulación de la vinculación. <br />
                El usuario y la contraseña suministrados por el socio son sus claves para acceder a los
                programas y servicios de LEO. Son personales e intransferibles, y el socio deberá
                adoptar las medidas de seguridad para evitar el uso fraudulento por terceros.
                </p>
                <br />

                <h4 align="center">CAPITULO III<br /></h4>
                <h5 align="left"> <b>PROGRAMAS Y SERVICIOS</b></h5>
                <br />
                <p>
                <b>Artículo 7.</b> – El Club Mundial de Lectura LEO ofrece a sus socios programas y servicios
                orientados a promover y masificar la lectura, la escritura y el multilinguismo, para lo
                cual ha desarrollado y cuenta con los respectivos registros de derechos de autor de los
                instrumentos tecnológicos web. El acceso a los programas y servicios es gratuito para
                los socios, que no deberán pagar suma alguna por su uso.
                </p>
                <br />
                <p>
                <b>Artículo 8. – Promoción de la Lectura.</b> Los socios LEO pueden acceder gratuitamente
                a los siguientes servicios: <br />
                Biblioteca Digital LEO con más de 15.000 obras en 5 idiomas (español, inglés,
                francés, portugués e italiano) que se adiciona mensualmente con 50 nuevas obras, que
                los socios pueden acceder y usar a través del portal institucional clubleo.net, y leer online o descargar a su
                dispositivo (PC, Celular o tableta). <br />
                <br />
                Vamosaleer: periódico digital con noticias y artículos sobre los géneros, obras y
                autores más represenativos o importantes, para información y motivación de la lectura y la escritura 
                de los socios LEO, disponible en la página institucional www.vamosaleer.co. <br />

                <b>Artículo 9. – Promoción de la Escritura.</b> LEO ha desarrollado el portal www.escritores.
                leo.com, una red social en la que, gratuitamente, los socios pueden ingresar y crear su
                perfil de escritor, y subir las obras de su autoría, que podrán ser consultadas por los
                demás miembros de la comunidad en el país y el mundo. Al Crear su perfil de escritor y
                subir sus obras, el respectivo socio expresamente garantiza que cumple con las normas
                sobre derechos de autor vigentes, y autoriza su publicación en el portal para ser
                consultadas por los demás usuarios.
                </p>

                <h4 align="center">CAPITULO IV<br /></h4>
                <h5 align="left"> <b>MANEJO DE LA INFORMACION</b></h5>
                <br />
                <p>
                <b>Artículo 10. – Seguridad y Confidencialidad.</b> Al registrarse, las personas autorizan a
                LEO a utilizar la información suministrada para efectos de identificación, verificación de
                la calidad de socio, y acceso a los programas y servicios establecidos en el Club
                Mundial de Lectura. <br />
                LEO adoptará las medidas conducentes a garantizar la seguridad y confidencialidad de
                la información suministrada por los socios en su registro y en las demás actividades que
                desarrollen dentro del programa. <br />
                La información de los socios solo será utilizada por LEO para la eficiente prestación de
                los programas y servicios establecidos en este reglamento, sin que terceros ajenos al
                Club puedan acceder a dicha información.
                </p>
                <br />
                <p>
                <b>Artículo 11. Aprobación.</b> - Reglamento 01 aprobado por la Editorial Educativa Bibliocol SAS
                  y la Asociación LEO Club Mundial de Lectura, en su reunión conjunta del 4 de agosto de 2025.
                </p>
                <br />
                <p>
                <b>DIANA MARCELA ROMERO ROJAS</b> <br />
                Directora
                </p>
                <br />
            </div>
          </div>      
        <br />
    </div>
  );
}
